var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 84,
    height: 84,
    fill: "#3EA959"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0007 36L39.334 48L34 42M60 30.3999V53.5999C60 55.8401 60.0004 56.9604 59.5645 57.8161C59.181 58.5687 58.5682 59.1805 57.8156 59.564C56.9599 59.9999 55.8406 60 53.6004 60H30.4004C28.1602 60 27.0392 59.9999 26.1836 59.564C25.4309 59.1805 24.8195 58.5687 24.436 57.8161C24 56.9604 24 55.8401 24 53.5999V30.3999C24 28.1597 24 27.0397 24.436 26.1841C24.8195 25.4314 25.4309 24.8195 26.1836 24.436C27.0392 24 28.1602 24 30.4004 24H53.6004C55.8406 24 56.9599 24 57.8156 24.436C58.5682 24.8195 59.181 25.4314 59.5645 26.1841C60.0004 27.0397 60 28.1597 60 30.3999Z",
    stroke: "#3EA959",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessModal);
export default __webpack_public_path__ + "static/media/success-modal.4f6a370f638cd39c2f8ded8cbe4b958d.svg";
export { ForwardRef as ReactComponent };